import { Skeleton } from 'primereact/skeleton';
import classes from './loading.module.scss';

const SupplierForecastSkeleton = () => {
  return (
    <div className={classes.tabSkeletonSkeleton}>
      <div className={classes.tabSkeletonHeading}>
        <Skeleton height="99vh" width="100vw"></Skeleton>
      </div>
    </div>
  );
};

export default SupplierForecastSkeleton;
